module.exports = __webpack_public_path__ + "img/six-dimension-logo.ad03d01d.png";